var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMediaWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.800781 4.20039C0.800781 3.20628 1.60667 2.40039 2.60078 2.40039H13.4008C14.3949 2.40039 15.2008 3.20628 15.2008 4.20039V11.8004C15.2008 12.7945 14.3949 13.6004 13.4008 13.6004H2.60078C1.60667 13.6004 0.800781 12.7945 0.800781 11.8004V4.20039ZM2.00078 8.84892V11.8004C2.00078 12.1318 2.26941 12.4004 2.60078 12.4004H13.4008C13.7322 12.4004 14.0008 12.1318 14.0008 11.8004V9.64892L12.225 7.87318C11.9907 7.63887 11.6108 7.63887 11.3765 7.87318L9.84931 9.40039L10.225 9.77613C10.4594 10.0104 10.4594 10.3903 10.225 10.6247C9.99073 10.859 9.61083 10.859 9.37652 10.6247L5.22504 6.47318C4.99073 6.23887 4.61083 6.23887 4.37652 6.47318L2.00078 8.84892ZM9.60078 5.60039C9.60078 6.04222 9.24261 6.40039 8.80078 6.40039C8.35895 6.40039 8.00078 6.04222 8.00078 5.60039C8.00078 5.15856 8.35895 4.80039 8.80078 4.80039C9.24261 4.80039 9.60078 5.15856 9.60078 5.60039Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaWhite);
export default __webpack_public_path__ + "static/media/media-white.8a67e8069abe9fe181a836cefaa6d572.svg";
export { ForwardRef as ReactComponent };